(function () {
  function setItemState(item, open) {
    if (!item) return;
    var btn = item.querySelector('.faq-question');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.faqInit === 'true') return;

    var items = sectionEl.querySelectorAll('.faq-item');
    if (!items.length) return;

    sectionEl.dataset.faqInit = 'true';

    items.forEach(function (item) {
      var btn = item.querySelector('.faq-question');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          setItemState(other, false);
        });

        if (!isOpen) {
          setItemState(item, true);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.section-openear-faq').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.section-openear-faq');
    if (section) initSection(section);
  });
})();
